import React, { Component } from 'react';
export default class Toast extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <div id="toast-container" className="toast-top-center">
                    <div className={this.props.type==="success" || this.props.type==="INFO" || this.props.type==="OK" ?"toast toast-success":this.props.type==="error" || this.props.type==="ERROR"?"toast toast-error":"toast toast-warning"} aria-live="polite">
                        <div className="toast-message">{this.props.notification}</div>
                    </div>
            </div>
        )
    }
}
